export function onlyNumbers(value: string) {
  return value.replace(/\D+/g, '');
}

export function onlyDocumentChars(value?: string | null) {
  return String(value ?? '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

export function capitalizeAllFirstLetters(value: string) {
  if (!value) return '';
  let arr = value.split(' ');
  arr = arr.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );

  return arr.join(' ');
}

export function capitalizeFirstLetter(value: string) {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
}
